<template>
    <div class="min-h-screen">
        <div class="relative sm:h-screen text-primary">
            <div class="bg-primary w-screen sm:h-[80vh]">
                <div class="container h-full">
                    <div
                        class="absolute z-10 inline-block transform left-8 bottom-24 rotate-6"
                    >
                        <!-- Mark -->
                        <!-- <WidgetMarkComponent
                            data-scroll
                            data-scroll-speed="1.8"
                            class="z-10 hidden md:block"
                            :text="$t('profile.head.marking')"
                            :delay="750"
                        /> -->
                    </div>
                    <div class="absolute bottom-0 left-0 z-0 max-w-3xl">
                        <img
                            class="w-full h-full"
                            src="@/assets/images/portrait.jpg"
                            alt=""
                        />
                    </div>
                    <div class="grid w-full h-full grid-cols-2">
                        <div class="hidden md:block"></div>
                        <div
                            class="flex items-center col-span-2 md:pt-56 md:col-span-1"
                        >
                            <div ref="headText" class="mt-32 sm:mt-0">
                                <h1
                                    data-animation="FADE_UP_TEXT_BLUR"
                                    class="relative mt-12 opacity-0 z-100 sm:mt-0 font-display text-7xl md:text-9xl"
                                >
                                    {{ $t('profile.head.lead') }}
                                </h1>
                                <div>
                                    <!-- <p
                                        data-scroll
                                        data-scroll-speed="1.4"
                                        data-scroll-delay="0.6"
                                        class="max-w-2xl mt-6 text-lg leading-loose"
                                    >
                                        {{ $t('profile.head.paragraph') }}
                                    </p> -->
                                    <ParagraphComponent
                                        data-animation="FADE_UP"
                                        data-animation-delay="0.75"
                                        size="large"
                                        class="relative z-10 mt-6 mb-[21.5rem] sm:mb-24 leading-relaxed sm:leading-loose max-w-xl sm:pl-2 opacity-0"
                                        :text="$t('profile.head.paragraph')"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- TODO - enable again -->
        <!-- <section class="container my-36">
            <div class="grid-cols-5 gap-36 space-y-28 lg:grid lg:space-y-0">
                <div class="relative z-10 col-span-2">
                    <div class="relative">
                        <h3 data-scroll data-scroll-speed="1.3" data-scroll-class="FADE_UP"
                            class="mb-4 text-xl italic font-bold text-text">
                            {{ $t("profile.section-1.headline") }}
                        </h3>
                        <ParagraphComponent data-scroll data-scroll-speed="1.6" data-scroll-class="FADE_UP"
                            class="max-w-[450px]" :text="$t('profile.section-1.paragraph')" />
                        <div data-scroll data-scroll-speed="1" data-scroll-class="FADE_UP"
                            class="absolute right-3/4 -bottom-8 h-[1px] w-screen bg-primary lg:right-0"></div>
                    </div>
                </div>
                <div class="absolute col-span-3 sm:relative h-80">
                    <WidgetMapComponent
                        data-scroll
                        data-scroll-speed="2"
                        data-scroll-delay="0.2"
                        class="absolute -top-28 sm:-top-40 left-40 sm:left-12 md:left-0 md:w-full w-[622px] h-[330px] sm:w-[830px] sm:h-[440px]"
                    />
                </div>
                <div class="relative pl-20">
                    <div class="absolute xl:w-[600px] xl:-top-52">
                        <div class="pl-8">
                            <div class="flex mb-10 gap-x-24">
                                <ProfileClimbingIconAnimation />
                                <ProfileFilmIconAnimation />
                            </div>
                            <Icon
                            name="heroicons:arrow-down"
                            class="w-10 h-10 mb-16 animate-[pulse_2.5s_ease-in-out_infinite]"
                        />
                            <h2 class="text-3xl font-display">
                                Things I do in my freetime
                            </h2>
                        </div>
                    </div>
                </div>
            </div>
        </section> -->

        <!-- <div
            data-scroll
            data-scroll-call="FADE_UP"
            class="bg-red-400 fade-up h-96 w-96"
        ></div> -->

        <section class="container my-48 mt-64 sm:mt-40">
            <h2
                ref="section2txt"
                class="max-w-5xl text-4xl leading-tight break-words whitespace-pre-line font-display sm:text-6xl md:text-7xl"
            >
                {{ $t('profile.section-2.paragraph') }}
            </h2>
        </section>

        <section class="container relative my-56 space-y-20 sm:-space-y-24">
            <div class="relative block mb-24 sm:hidden">
                <h2
                    data-animation="FADE_UP_TEXT"
                    class="text-5xl font-bold font-display"
                >
                    {{ $t('profile.section-3.headline') }}
                </h2>
                <div
                    class="absolute right-3/4 -bottom-8 h-[1px] w-screen bg-primary lg:right-0"
                ></div>
            </div>
            <WidgetProfileCareerComponent
                :index="0"
                :title="$t('profile.section-3.career.apprenticeship')"
                :from="2017"
                :to="2018"
                :images="['about-lehre-1.jpg', 'about-lehre-2.jpg']"
            />
            <WidgetProfileCareerComponent
                :index="1"
                :title="$t('profile.section-3.career.wda')"
                :from="2018"
                :to="2020"
                :images="[
                    'about-1.jpg',
                    'about-2.jpg',
                    'about-3.jpg',
                    'about-4.jpg',
                ]"
            />
            <WidgetProfileCareerComponent
                :index="2"
                :title="$t('profile.section-3.career.factor')"
                :from="2019"
                :to="2020"
                :images="['about-factor-1.jpg', 'about-factor-2.jpg']"
            />
            <WidgetProfileCareerComponent
                :index="1"
                :title="$t('profile.section-3.career.clubdrei')"
                :from="2022"
                :to="2024"
                :images="[
                    'about-clubdrei-1.jpg',
                    'about-clubdrei-2.jpg',
                    'about-clubdrei-3.jpg',
                    'about-clubdrei-4.jpg',
                ]"
            />
        </section>
    </div>
</template>

<script setup lang="ts">
// Meta
definePageMeta({
    title: 'profile.meta.title',
    description: 'profile.meta.description',
});

// Hooks
onMounted(() => {
    // this.animateHead();
    // this.animateSection2Txt();
});
</script>

<!-- <script lang="ts">
import { sanitize } from "@/utility/Helpers";

export default defineNuxtComponent({
    name: "ProfilePage",
    components: {
        // MapComponent,
        // ProfileCareerComponent,
        // MarkComponent,
    },
    head() {
        return {
            title: "Profile",
            meta: [
                {
                    hid: "description",
                    name: "description",
                    content: (this as any).$t("profile.meta.description"),
                },
            ],
        };
    },
    mounted() {
        this.animateHead();
        this.animateSection2Txt();

        // Update Locomotive Scroll
        setTimeout(() => {
            this.$nuxt.$emit("update-locomotive");
        }, 150);
    },
    methods: {
        sanitize,
        animateHead() {
            const anime = (this as any).$anime;
            const ref: HTMLElement = this.$refs.headText as HTMLElement;

            const letters: any = this.$letterize({
                targets: ref.childNodes[0],
                className: "inline-block",
            });

            const tl = anime.timeline({
                easing: "easeInOutQuad",
                duration: 1250,
                delay(_el: any, i: number) {
                    return i * 35;
                },
            });

            tl.add(
                {
                    targets: letters.listAll,
                    translateY: [75, 0],
                    opacity: [0, 1],
                },
                500
            );

            tl.add(
                {
                    targets: ref.childNodes[2],
                    translateY: [50, 0],
                    opacity: [0, 1],
                },
                "-=1250"
            );
        },
        animateSection2Txt() {
            const anime = (this as any).$anime;
            const ref: any = this.$refs.section2txt;

            let letters: any;

            if (window.innerWidth > 480) {
                letters = this.$letterize({
                    targets: ref,
                    className: "inline-block",
                });
            }

            const animation = anime({
                targets: window.innerWidth > 480 ? letters.listAll : ref,
                easing: "easeInOutQuad",
                duration: 750,
                translateY: [75, 0],
                opacity: [0, 1],
                delay(_el: any, i: number) {
                    return i * 35;
                },
                autoplay: false,
            });

            setTimeout(() => {
                this.$locomotive.on("call", (e: any) => {
                    if (e === "PROFILE_SECTION2_ANIMATE_PARAGRAPH")
                        animation.play();
                });
            }, 100);
        },
    },
});
</script> -->
